import { render, staticRenderFns } from "./Tinformation.vue?vue&type=template&id=f2ef217e&"
import script from "./Tinformation.vue?vue&type=script&lang=js&"
export * from "./Tinformation.vue?vue&type=script&lang=js&"
import style0 from "./Tinformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports